/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [page-not-found.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 10.01.20, 10:51
 */

import React from 'react';
import {Link} from 'react-router-dom';
import {useLanguage} from "../configuration/configuration";
import {useQueryParams} from "../hooks/use-query-params";

const ErrorPage = () => {
    const {status, error, message} = useQueryParams('status', 'error', 'message');
    const Lang = useLanguage();

    console.log('ERROR', status, error, message)

    return <div className='error-page-container error-page-container-bg'>
        <div className='error-page-body'>
            <div className='teaser'>{status && status || 400}</div>
            <div className='message'>{Lang.errorPage.text}
                {message && <div className='message-small'>{message}</div>}
                {error && <div className='message-small'>{error}</div>}
            </div>
        </div>
        <div className='page-not-found-link'>
            <span className='mr-1'>{Lang.errorPage.back}</span>
            <Link to='/'>{Lang.errorPage.home}</Link>
        </div>
    </div>
};

export default ErrorPage;